// const e=new window.Swiper("#main-product-thumbs-swiper",{spaceBetween:10,slidesPerView:4});new window.Swiper("#main-product-gallery-swiper",{thumbs:{swiper:e}});$(".product-tabs ").on("click",".tabs-head > li:not(.active)",function(){const i=$(this).index();$(this).siblings().removeClass("active"),$(this).addClass("active"),i===0?($(".product-recommendations").hide(),$(".tab-description").show()):($(".tab-description").hide(),$(".product-recommendations").show())});
// 确保引入了 jQuery 和 Swiper 的 JavaScript 文件

$(document).ready(function() {
  // 初始化缩略图 Swiper 实例
  const thumbsSwiper = new Swiper('#main-product-thumbs-swiper', {
    spaceBetween: 10,
    
    slidesPerView: 4,
        observer:true,
    observeParents:true,
    freeMode: true, // 允许自由滑动
    watchSlidesVisibility: true, // 监听幻灯片的可见性变化
    watchSlidesProgress: true, // 监听幻灯片的滑动进度
  
  });

  // 初始化主 Swiper 实例，并关联到缩略图 Swiper
  const gallerySwiper = new Swiper('#main-product-gallery-swiper', {
    spaceBetween: 10,
    thumbs: {
      swiper: thumbsSwiper,
       autoScrollOffset: 4
    },   
    navigation: {
    nextEl: '.main-graphic-next',
      prevEl: '.main-graphic-prev',
    },
  });

  // 监听 gallerySwiper 的 transitionEnd 事件
  gallerySwiper.on('transitionEnd', function () {
  
  });

  // 处理产品标签切换
  $('.product-tabs').on('click', '.tabs-head > li:not(.active)', function () {
    const i = $(this).index();
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    if (i === 0) {
      $('.scm-container').hide();
      $('.product-recommendations').hide();
      $('.tab-description').show();
    } else if (i == 2){
      $('.scm-container').hide();
      $('.tab-description').hide();
      $('.product-recommendations').show();
      
       
    }else {
      $('.tab-description').hide();
      $('.product-recommendations').hide();
      $('.scm-container').show();
    }
  });
});